import { useState, useEffect } from "react";
import { ShieldCheck, CheckCircle2, Lock } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import BackToHome from "@/components/portal/BackToHome";

export default function SetPassword() {
  const [token, setToken] = useState("");
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const t = new URLSearchParams(window.location.search).get("token") || "";
    setToken(t);
    if (!t) setErr("This link is missing its security token. Please use the link from your welcome email.");
  }, []);

  const submit = async () => {
    setErr("");
    if (pw.length < 8) { setErr("Password must be at least 8 characters."); return; }
    if (pw !== confirm) { setErr("Passwords do not match."); return; }
    setBusy(true);
    try {
      await api.post("/auth/set-password", { token, new_password: pw });
      setDone(true);
      setTimeout(() => { window.location.href = "/patient"; }, 1500);
    } catch (e) { setErr(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="adm" data-testid="set-password-page">
      <div className="login-shell" style={{ gridColumn: "1 / -1" }}>
        <div style={{ position: "absolute", top: 24, left: 24 }}><BackToHome /></div>
        <div className="login-card" style={{ maxWidth: 440 }}>
          {done ? (
            <div style={{ textAlign: "center" }} data-testid="set-password-success">
              <CheckCircle2 size={44} color="#1D9E75" />
              <h2 style={{ fontFamily: "Fraunces,serif", fontWeight: 540, margin: "12px 0 6px" }}>Password set ✓</h2>
              <p style={{ color: "var(--slate)", fontSize: 14 }}>You're all set. Taking you to your patient dashboard…</p>
            </div>
          ) : (
            <>
              <div className="side-logo" style={{ margin: "0 auto 14px", display: "grid", placeItems: "center" }}><ShieldCheck size={20} /></div>
              <h2 style={{ fontFamily: "Fraunces,serif", fontWeight: 540, textAlign: "center", margin: "0 0 4px" }}>Set your password</h2>
              <p style={{ color: "var(--slate)", fontSize: 13.5, textAlign: "center", margin: "0 0 20px" }}>Create your own secure password to access your patient account.</p>
              {err && <p style={{ color: "var(--danger,#C0392B)", fontSize: 13 }} data-testid="set-password-error">{err}</p>}
              <div className="field"><label>New password (min 8 chars)</label>
                <input className="in" type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="set-password-new" />
              </div>
              <div className="field"><label>Confirm password</label>
                <input className="in" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} data-testid="set-password-confirm" />
              </div>
              <button className="btn btn-ink" style={{ width: "100%", justifyContent: "center" }} onClick={submit} disabled={busy || !token} data-testid="set-password-submit">
                <Lock size={15} /> {busy ? "Setting…" : "Set password & continue"}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
